module.exports = new __parcel__URL__("kyc.31754f12.svg").toString();